const AssignmentStatus = ({ assignmentMarks }) => {
  const totalPending = assignmentMarks?.filter(
    (assignmentMark) => assignmentMark.status === "pending"
  );

  const totalPublished = assignmentMarks?.filter(
    (assignmentMark) => assignmentMark.status === "published"
  );

  return (
    <ul className="assignment-status">
      <li>
        Total <span>{assignmentMarks?.length}</span>
      </li>
      <li>
        Pending <span>{totalPending?.length}</span>
      </li>
      <li>
        Mark Sent <span>{totalPublished?.length}</span>
      </li>
    </ul>
  );
};

export default AssignmentStatus;
